
import { useState } from "react";
import { PasswordForm } from "./PasswordForm";

type LoginFormProps = {
  onSubmit: (data: any) => void;
  onForgotPassword?: () => void;
};

export const LoginForm = ({ onSubmit, onForgotPassword }: LoginFormProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      await onSubmit(data);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <PasswordForm 
        onSubmit={handleSubmit} 
        isLoading={isLoading} 
        onForgotPassword={onForgotPassword}
      />
    </div>
  );
};
